export default __webpack_public_path__ + "static/media/bj.aa241e03.svg";